export default __webpack_public_path__ + "static/media/trash.18d4b87d.svg";